exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu_drop.submenu-left{right:auto;left:-60px}", ""]);

// exports
